import { render, staticRenderFns } from "./AlcoholModal.vue?vue&type=template&id=a04c0278&scoped=true&lang=pug&"
import script from "./AlcoholModal.vue?vue&type=script&lang=js&"
export * from "./AlcoholModal.vue?vue&type=script&lang=js&"
import style0 from "./AlcoholModal.vue?vue&type=style&index=0&id=a04c0278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04c0278",
  null
  
)

export default component.exports